/***** SCRIPTS POUR GERER LES FORMULAIRES *****/
  
  $('document').ready(setupForms);
  let nbChampVide = 0;
  let siteUrl = window.location.protocol + '//' + window.location.hostname;
  
  function setupForms() {
    resetForm();
    initNewsletterSubscription();
    $('.wpcf7-form input[type="submit"], .wpcf7-form .wpcf7-submit, .contactform .wpcf7-submit').click(testerFormulaire);
  }
  
  // Fonction qui permet de tester les formulaires
  function testerFormulaire(e) {
    let formId = $(this).parent().parent().parent().parent().attr('id');
    if(formId === undefined) formId = $(this).parent().parent().parent().parent().parent().parent().attr('id');
    
    // vérification des saisies utilisateurs
    nbChampVide = 0;
    $('#' + formId+ ' .error-msg').fadeOut(200);
    $('#' + formId+ ' .error').removeClass('error');
    $('#' + formId+ ' .valid').removeClass('valid');
    
    // On vérifie que l'utilisateur a coché les cases RGPD
    if($('#' + formId+ ' input[name="rgpd"]').prop( "checked" ) === false || $('#' + formId+ ' input[name="rgpd[]"]').prop( "checked" ) === false || $('#' + formId+ ' input[name="rgpd_share[]"]').prop( "checked" ) === false || $('#' + formId+ ' input[name="rgpd_newsletter[]"]').prop( "checked" ) === false) {
      $('#' + formId+ ' input[name="rgpd"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
      $('#' + formId+ ' input[name="rgpd[]"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
      $('#' + formId+ ' input[name="rgpd_share[]"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
      $('#' + formId+ ' input[name="rgpd_newsletter[]"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
      nbChampVide++;
    }
    
    // On vérifie s'il y a des boutons radios obligatoires
    $('#' + formId+ ' .wpcf7-radio').each(function () {
      if($(this).find('input:checked').length === 0) {
        $(this).addClass('error');
        $(this).parent().children('.error-msg').fadeIn(300);
        nbChampVide++;
      }else {
        $(this).addClass('valid');
      }
    });
    
    // On vérifie s'il y a des select list obligatoire
    $('#' + formId+ ' .form > div:not(.wpcf7cf-hidden) select.wpcf7-validates-as-required').each(function () {
      if($(this).val() == '' || $(this).val() == ' ' || $(this).val() === '- Aucun -') {
        $(this).addClass('error');
        $(this).parent().children('.error-msg').fadeIn(300);
        nbChampVide++;
      }else {
        $(this).addClass('valid');
      }
    });
    
    // On vérifie la saisie des champs obligatoire
    $('#' + formId+ ' div:not(.wpcf7cf-hidden) input.wpcf7-validates-as-required').each(function() {
      if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
        nbChampVide++;
        $(this).addClass('error');
        $(this).parent().children('.error-msg').fadeIn(300);
      }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
        var name = $(this).attr('name');
        if(name === 'email' || name === 'email_share') {
          let emailVal = $(this).val();
          $(this).val(emailVal.replace('.@', '@'));
          var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
          if (regex.test($(this).val()) == false) {
            nbChampVide++;
            $(this).addClass('error');
            $(this).parent().children('.error-msg').fadeIn(300);
            console.log($(this));
          }else {
            $(this).addClass('valid');
          }
        }else if(name === 'telephone') {
          var regexPhone = /^((\+|00)(3|33)\s?|0)[1-7](\s?\d{2}){4}$/;
          var regexBelgiumPhone = /^((\+|00)(3|33)\s?|0)(\d\s?\d{3}|\d{2}\s?\d{2})(\s?\d{2}){2}$/;
          if (regexPhone.test($(this).val()) === false && regexBelgiumPhone.test($(this).val()) === false) {
            nbChampVide++;
            $(this).addClass('error');
            $(this).parent().children('.error-msg').fadeIn(300);
          }else {
            $(this).addClass('valid');
          }
        }else {
          $(this).addClass('valid');
        }
      }
    });
    
    // On vérifie que les textarea requis sont renseignés
    $('#' + formId+ ' .form textarea.wpcf7-validates-as-required, #' + formId+ ' .wpcf7-form textarea.wpcf7-validates-as-required').each(function() {
      if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
        nbChampVide++;
        $(this).addClass('error');
        $(this).parent().children('.error-msg').fadeIn(300);
      }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
        $(this).addClass('valid');
      }
    });
    
    if(nbChampVide !== 0) {
      e.preventDefault();
      if(!$('#shareEmailModal').hasClass('open') && !$('#newsletterModal').hasClass('open') && $('#' + formId+ ' .error').length !== 0) $("html, body").animate({ scrollTop: $('#' + formId+ ' .error').offset().top - 145 }, 500);
    }else {
      $('body > .loading').addClass('show');
      $("html, body").css('overflow', 'hidden');
      // Formulaire de demande de contact
      if($('#devis').length !== 0 || $('#profil').length !== 0) {
        document.addEventListener( 'wpcf7mailsent', function( event ) {
          let formulaireID = $(event.target).children('.form').attr('id');
          $('.loading').removeClass('show');
          $("html, body").removeAttr('style');
          $(event.target).children('.form').fadeOut(400, function() {
            $(event.target).find('.validation-msg').fadeIn(400);
          });
        });
        
        document.addEventListener( 'wpcf7mailfailed', function( event ) {
          let formulaireID = $(event.target).children('.form').attr('id');
          console.log( 'erreur d\'envoi');
          $('.loading').removeClass('show');
          $("html, body").removeAttr('style');
          $(event.target).find('.validation-msg .wrapper-msg').html('<div class="title-msg">Désolé, une erreur est survenue...</div>\n' +
              '       <p>Votre message n\'a malheureusement pas pu être envoyé.<br/>Veuillez essayer ultérieurement ou nous contacter directement par téléphone.</p>\n' +
              '       <a href="' + siteUrl + '" class="btn btn-main">Retourner sur la page d\'accueil</a>');
          $(event.target).find('.validation-msg').addClass('error');
          $(event.target).children('.form').fadeOut(400, function() {
            $(event.target).find('.validation-msg').fadeIn(400);
          });
        });
      }
    }
  }

  // Inscription à la newsletter
  function initNewsletterSubscription() {
    $('.registerNewsletter').click(function(e) {
      e.preventDefault();
      $('.fadebg').addClass('show');
      $('html, body').css('overflow', 'hidden');
      $('#newsletterModal').addClass('open');
    });
    
    $('.modal-close, .fabebg').click(function() {
      $('.modal').removeClass('open');
      $('.fadebg').removeClass('show');
      $('html, body').removeAttr('style');
    });
    
    // Envoi du formulaire d'inscription à la newsletter
    $('#form-newsletter .wpcf7-form').submit(function(e) {
      e.preventDefault();
      let formValues= $(this).serialize();
      let form = $(this);
      $.post($(this).attr('action'), formValues, function(response) {
        if($('.newsletter-form').length !== 0) $("html, body").removeAttr('style');
        if(response.indexOf('#newsletter-result') !== -1) {
          window._mtm = window._mtm || [];
          window._mtm.push({
            'event': 'form_submission_newsletter',
          });
          form.parent().parent().find('.text').hide();
          form.children('.form').fadeOut(400, function() {
            form.find('.validation-msg:not(.errorform)').fadeIn(400);
          });
        }else if(response.indexOf('#newsletter-newsletter-error') !== -1) {
          form.parent().parent().find('.text').hide();
          form.children('.form').fadeOut(400, function() {
            form.find('.validation-msg.errorform').fadeIn(400);
          });
        }
        $('.loading').removeClass('show');
      });
    });
  }
  
  function resetForm() {
    $('.btn-reinit').click(function() {
      $('.documents-filters input[type="checkbox"]').prop('checked', false);
      $('.documents-filters').submit();
    });
  }
